import styled, { css } from "styled-components";

import { ActionsStyledProps } from "./Actions.types";

export const Actions = styled.div<ActionsStyledProps>`
  flex: 1 1 auto;
  display: grid;
  grid-template-columns: repeat(${props => props.childrenSize}, 1fr);
  grid-auto-flow: column;
  align-items: flex-end;
  justify-content: center;
  gap: ${props => props.theme.spacing.spacing_16};

  ${props => props.theme.breakpoints.desktop} {
    ${props =>
      props.direction === "horizontal" &&
      css`
        display: flex;
        justify-content: flex-end;
      `}

    ${props =>
      props.direction === "vertical" &&
      props.childrenSize === 1 &&
      css`
        grid-template-columns: 60%;
      `}
  }
`;
